export const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_Os1G0OtXQ',
      userPoolClientId: '19llk92vihba0e91r3jd9nkjs5',
      loginWith: {
        email: true,
        
      }
    }
  }
};